import { render, staticRenderFns } from "./ModuleContainer.vue?vue&type=template&id=035c81a3&scoped=true&"
import script from "./ModuleContainer.vue?vue&type=script&lang=js&"
export * from "./ModuleContainer.vue?vue&type=script&lang=js&"
import style0 from "./ModuleContainer.vue?vue&type=style&index=0&id=035c81a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035c81a3",
  null
  
)

export default component.exports